import { autocatalogConstants } from '../constants';

export function autocatalog(state = {}, action) {
  switch (action.type) {
    case autocatalogConstants.FETCH_BRANDS_REQUEST:
      return {
        loading: true
      };
    case autocatalogConstants.FETCH_BRANDS_SUCCESS:
      return {
        ready: true,
        brands: action.brands
      };
    case autocatalogConstants.FETCH_BRANDS_FAIL:
      return {
        ...state,
        error: action.error
      };
    case autocatalogConstants.FETCH_MODELS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case autocatalogConstants.FETCH_MODELS_SUCCESS:
      return {
        ready: true,
        brands: state.brands,
        models: action.models
      };
    case autocatalogConstants.FETCH_MODELS_FAIL:
      return {
        ...state,
        error: action.error
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/autocatalog.js